import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-priceIndicatorDrawer`

const LITERALS = 'PRICE_INDICATOR'

export const LITERAL_KEYS = {
  COACHMARK_RANK: `${LITERALS}.COACHMARK_RANK`,
  DESCRIPTION_PREFIX: `${LITERALS}.DESCRIPTION_PREFIX`,
  HEADLINE: `${LITERALS}.HEADLINE`,
  SCALE_DESCRIPTION: `${LITERALS}.SCALE_DESCRIPTION`,
  TITLE: `${LITERALS}.DRAWER_TITLE`
}

const NEUTRALITY_LEGAL_TEXT = `${LITERALS}.LEGAL_TEXT_NEUTRALITY`
const SELLER_LEGAL_TEXT = `${LITERALS}.LEGAL_TEXT_SELLER`

const USED_VEHICLE_CONFIG = {
  averageLabelKey: 'COMMON.MARKET_VALUE',
  comparisonKeyPrefix: `${LITERALS}.USED_VEHICLE.COMPARISON_RANK_`,
  descriptionSuffixKey: `${LITERALS}.USED_VEHICLE.DESCRIPTION_SUFFIX`,
  hasAverage: true,
  legalTextKeys: [NEUTRALITY_LEGAL_TEXT, `${LITERALS}.USED_VEHICLE.LEGAL_TEXT`, SELLER_LEGAL_TEXT]
}

const NEW_VEHICLE_CONFIG = {
  averageLabelKey: 'COMMON.OFFICIAL_PRICE',
  comparisonKeyPrefix: `${LITERALS}.NEW_VEHICLE.COMPARISON_RANK_`,
  descriptionSuffixKey: `${LITERALS}.NEW_VEHICLE.DESCRIPTION_SUFFIX`,
  hasAverage: true,
  legalTextKeys: [NEUTRALITY_LEGAL_TEXT, `${LITERALS}.NEW_VEHICLE.LEGAL_TEXT`, SELLER_LEGAL_TEXT]
}

const RENTING_CONFIG = {
  comparisonKeyPrefix: `${LITERALS}.RENTING.COMPARISON_RANK_`,
  descriptionSuffixKey: `${LITERALS}.RENTING.DESCRIPTION_SUFFIX`,
  hasAverage: false,
  legalTextKeys: [
    NEUTRALITY_LEGAL_TEXT,
    `${LITERALS}.RENTING.LEGAL_TEXT_APPRAISAL`,
    `${LITERALS}.RENTING.LEGAL_TEXT_SERVICES`
  ]
}

export const getDrawerConfig = ({offerTypeId, offerTypes}) => {
  const {OFFER_TYPE_NEW, OFFER_TYPE_SUBSCRIPTION} = offerTypes

  if (offerTypeId === OFFER_TYPE_NEW) return NEW_VEHICLE_CONFIG
  if (offerTypeId === OFFER_TYPE_SUBSCRIPTION) return RENTING_CONFIG
  return USED_VEHICLE_CONFIG
}

// Cheapest rank first, as the indicator is displayed
export const getRanks = ({PRICE_INDICATOR_COLOR_RANK, PRICE_INDICATOR_LABEL_RANK, PRICE_INDICATOR_VALUE_RANK}) =>
  Object.values(PRICE_INDICATOR_VALUE_RANK)
    .reverse()
    .map(value => ({
      color: PRICE_INDICATOR_COLOR_RANK[value],
      label: PRICE_INDICATOR_LABEL_RANK[value],
      value
    }))
